import React from 'react';
import { DocumentList, UploadButton } from 'components/fields';
import { PromptItem } from 'types/candidateStories';

const FilePromptUploadSection = ({
  item,
  documents,
  onRemove,
  field,
}: {
  item: PromptItem;
  documents: any[];
  onRemove: (index: number) => void;
  field: string;
}) => {
  return (
    <div data-testid={`file-prompt-upload-section-${item.id}`}>
      <div
        className='mt-3 mb-3'
        data-testid='candidate-story-upload-btn-section'
      >
        <UploadButton
          name={field}
          kind='secondary'
          context='candidate-stories'
        />
      </div>
      <div className='form-group'>
        <DocumentList documents={documents} onRemove={onRemove} />
      </div>
    </div>
  );
};

export default FilePromptUploadSection;
